import Hero from "../../components/Hero/Hero";
import HomeGoTos from "../../components/HomeGoTos/HomeGoTos";
import IAmA from "../../components/IAmA/IAmA";
import ProjectSection from "../../components/ProjectSection/ProjectSection";
import Skills from "../../components/Skills/Skills";

const Home = () => {
  return (
    <>
      <div>
        <Hero />
        <IAmA />
        <ProjectSection />
        <Skills />
        <HomeGoTos />
      </div>
    </>
  );
};

export default Home;
